export const GET_URLUPGRADE_API_REQUEST = "GET_URLUPGRADE_API_REQUEST";
export const GET_URLUPGRADE_API_SUCCESS = "GET_URLUPGRADE_API_SUCCESS";
export const GET_URLUPGRADE_API_ERROR = "GET_URLUPGRADE_API_ERROR";